import * as React from 'react';
import { ProductInterface } from '../../Model/Product';
import { ProductView } from './ProductView';

export interface RowProps {
    product: ProductInterface,
    key?: string
}

export abstract class AbstractRow<T extends RowProps = RowProps> extends ProductView<T> {
    public render() {
        const product = this.props.product;
        const rowId = 'row/' + product.guid;

        return <>
            <tr id={rowId + '-headline'} className='pf-row-headline' data-pf-guid={product.guid}>
                {this.renderHeadline(product)}
            </tr>
            <tr id={rowId + '-body'} className='pf-row-body' data-pf-guid={product.guid}>
                {this.renderCells()}
            </tr>
            <tr id={rowId + '-separator'} className='pf-row-separator' data-pf-guid={product.guid} aria-hidden={true}>
                <td colSpan={100}>&nbsp;</td>
            </tr>
        </>;
    }

    protected abstract renderCells(): JSX.Element;

    protected abstract renderHeadline(product: ProductInterface): JSX.Element;
}
